import React, { Component } from "react";
import Loading from "./Loading";
import PropTypes from "prop-types";
import InputRow from "./InputRow";

export default class FundingSource extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: "",
      fundingSourceData: [],
      selectedFundingSource: this.props.selectedFundingSource || "",
    };
  }

  componentDidMount() {
    // Simulating fetching funding source data, remove if not required
    this.setState({
      loading: false,
      fundingSourceData: [
        { Id: "SFND", value: "Self Funded" },
        { Id: "CFND", value: "Company Funded" },
      ],
    });
  }

  render() {
    const { loading, error, fundingSourceData, selectedFundingSource } =
      this.state;
    const { error: validationError } = this.props;

    if (loading) {
      return <Loading />;
    }

    return (
      <div id="height">
        <div>
          {error && <p style={{ color: "red" }}>{error}</p>}
          <InputRow
            name="select"
            rowName="Funding Source"
            value={selectedFundingSource}
            data={fundingSourceData}
            onChange={(e) => {
              this.setState({ selectedFundingSource: e });
              this.props.collectState("FS", {
                selectedFundingSource: e,
              });
            }}
          />
        </div>
        <button className="save" onClick={this.props.onSave}>
          Next
        </button>
      </div>
    );
  }
}

FundingSource.propTypes = {
  onSave: PropTypes.func.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  selectedFundingSource: PropTypes.string,
  collectState: PropTypes.func.isRequired,
  error: PropTypes.object,
};
